/* stylelint-disable selector-type-case */
/* stylelint-disable selector-type-no-unknown */

import styled, { css } from 'styled-components';
import { FONT_NAMES, FONT_WEIGHT } from 'core/styles/fonts';

import * as mx from 'core/styles/mixins';
import { CTA_CLASS } from 'core/components/Cta/Cta.style';

const CONTENT_IMAGE_PADDING = 32;

export const ImageBlock = styled.div<{
	isDashboardModule: boolean;
}>`
	width: 100%;
	z-index: 0;

	div {
		${({ isDashboardModule }) =>
			isDashboardModule &&
			css`
				height: 100%;
				width: 100%;
			`}
	}

	${({ isDashboardModule }) =>
		isDashboardModule &&
		css`
			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: 100% 0;
			}
		`}
`;

export const TextBlock = styled.div`
	width: 100%;
	z-index: 1;
	font-size: 16px;
	h3 {
		font-size: 24px;
		line-height: 32px;
		font-weight: ${FONT_WEIGHT.BOOK};
		font-family: ${FONT_NAMES.GOTHAM_ROUNDED_BOOKED};
	}
`;

export const NotificationBlock = styled.div<{ alignTop: boolean }>`
	width: 100%;
	z-index: 1;

	${({ alignTop }) =>
		alignTop
			? css`
					margin-bottom: 24px;
					margin-top: 0;
					order: 0;
			  `
			: css`
					margin-bottom: 0;
					margin-top: 24px;
					order: 3;
			  `}
`;

export const Text = styled.div<{ isDashboardModule: boolean }>`
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	${({ isDashboardModule }) =>
		isDashboardModule &&
		css`
			padding: 48px 24px 0px;
		`}
`;

export const CtaWrapper = styled.div<{
	isDashboardModule: boolean;
}>`
	${({ isDashboardModule }) =>
		isDashboardModule
			? css`
					padding: 4px 0 0;
			  `
			: css`
					padding: 20px 0 0;
			  `}
	display: flex;
	justify-content: space-between;

	.${CTA_CLASS} {
		margin: 0;

		&.cta-plain a {
			padding-left: 14px;
			padding-right: 14px;
		}
	}
`;

export const SecondaryCtaWrapper = styled.div`
	margin-left: auto;
`;

export const ContentBlock = styled.div<{
	imageAlignRight: boolean;
	hasImage: boolean;
	bpName: string;
	isImageCircle: boolean;
	isContentCentered: boolean;
	isDashboardModule: boolean;
}>`
	display: flex;
	flex-flow: row wrap;

	${({
		hasImage,
		bpName,
		imageAlignRight,
		isImageCircle,
		isContentCentered,
		isDashboardModule,
	}) =>
		hasImage &&
		css`
			${isDashboardModule &&
				css`
					min-height: 517px;
					height: inherit;
				`}
			${ImageBlock} {
				order: 2;
				margin-top: ${CONTENT_IMAGE_PADDING}px;
				${isDashboardModule &&
					css`
						min-height: 186px;
					`}
			}
			${TextBlock} {
				order: 1;
			}
			${isContentCentered &&
				css`
					text-align: center;
					box-sizing: content-box;
					display: flex;
					align-items: center;
					justify-content: center;

					${CtaWrapper} {
						justify-content: center;
					}
					${ImageBlock} {
						order: 1;
						display: flex;
						align-items: center;
						justify-content: center;
					}
					${TextBlock} {
						order: 2;
					}
				`}
			${isImageCircle &&
				css`
					img {
						${mx.circle('160px')}
					}

					${!isContentCentered &&
						css`
							${ImageBlock} {
								flex: 0;
							}
							${TextBlock} {
								flex: 1;
							}
						`}
				`}

			${mx.bpc('m', bpName)`
				${ImageBlock} {
					order: ${imageAlignRight ? 2 : 1};
				}
				${TextBlock} {
					order: ${imageAlignRight ? 1 : 2};
				}
				${ImageBlock},
				${TextBlock} {
					width: 50%;
					margin: 0;
				}

				${imageAlignRight ? ImageBlock : TextBlock} {
					padding-left: ${CONTENT_IMAGE_PADDING / 2}px;
				}

				${imageAlignRight ? TextBlock : ImageBlock} {
					padding-right: ${CONTENT_IMAGE_PADDING / 2}px;
				}
			`}
		`}
`;

export const Hr = styled.div`
	background-color: ${({ theme }) => theme.global.borders.module};
	height: 1px;
	width: calc(100% + 50px);
	margin-left: -25px;
`;
